import { getImageLink } from "domain/Announcements/actions";
import PropTypes from "prop-types";
import React from 'react';
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { makeSelectAnnouncementLink } from "../selectors";
import ImageField from "./ImageField";


function createImageFieldContainer(fieldName) {

    class ImageFieldContainer extends React.PureComponent {

        static propTypes = {
            label: PropTypes.string,
            file: PropTypes.object,
            link: PropTypes.string,
            getImageLink: PropTypes.func,
        };


        render() {
            return (
                <ImageField
                    {...this.props}
                />
            );
        }

    };

    const mapStateToProps = createStructuredSelector({
        link: makeSelectAnnouncementLink(),
    });

    const mapDispatchToProps = (dispatch) => ({
        getImageLink: (fileId) => dispatch(getImageLink(fileId, { fieldName })),
    });

    return connect(mapStateToProps, mapDispatchToProps)(ImageFieldContainer);

}

export default createImageFieldContainer;